import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=29364bb9"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29364bb9')) {
      api.createRecord('29364bb9', component.options)
    } else {
      api.reload('29364bb9', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=29364bb9", function () {
      api.rerender('29364bb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ds/Icon.vue"
export default component.exports